// Command mappings from technical codes to human-readable descriptions
export const COMMAND_DESCRIPTIONS: Record<string, string> = {
  // Pool Light Commands
  "get_pool_light_switch_mode": "Get Pool Light Switch Mode",
  "set_pool_light_switch_mode": "Set Pool Light Switch Mode",

  // Diagnostic Commands
  "diagnose": "Get Diagnostics",

  // Network Testing Commands
  "get_wifi_testing_result": "Get WiFi Testing Result",
  "get_eth_testing_result": "Get Ethernet Testing Result",
  "get_testing_result": "Get Testing Result",
  "set_device_mqtt": "Set Device MQTT",

  // System Commands
  "version_get": "Get Firmware Version",
  "boot_to_image": "Reboot Device",
  "pool_params_set": "Set Pool Parameters",
  "pool_params_get": "Get Pool Parameters",
  "get_wifi_list": "Get WiFi List",
  "refresh_wifi_list": "Refresh WiFi List",
  "set_device_details": "Set Device Details",
  "set_device_wifi": "Set Device WiFi",
  "setup_mode": "Setup Mode",
  "get_time": "Get Time",
  "set_time": "Set Time",
  "get_conn_status": "Get Network Info",

  // Background Commands
  "error_get": "Get Error",
  "error_info_get": "Get Error Info",
  "error_history_get": "Get Error History",
  "error_monitor": "Monitor Errors",
  "pause_get": "Get Pause Status",
  "pause_set": "Set Pause Status",
  "pause_monitor": "Monitor Pause",

  // Auxiliary Commands
  "aux_assign_get": "Get Aux Assignment",
  "aux_assign_set": "Set Aux Assignment",
  "set_pump_info": "Set Pump Info",
  "get_pump_info": "Get Pump Info",
  "get_aux_conflict": "Get Aux Conflict",
  "check_pool_light_assign": "Check Pool Light Assignment",

  // Pump Calibration Commands
  "check_flow_cali_necessity": "Check Flow Calibration Necessity",
  "calibrate_flow": "Calibrate Flow",

  // Dashboard Commands
  "dashboard_info": "Get Dashboard Info",
  "dashboard_device_info": "Get Dashboard Device Info",

  // Temperature Commands
  "v2_temp_get": "Get Temperature Info",
  "v2_temp_set": "Set Temperature Info",

  // Filtration Commands
  "v2_filtration_get": "Get Filtration Info",

  // Chemistry Commands
  "v2_chemistry_get": "Get Chemistry Info",

  // Schedule Commands
  "v2_schedule_get": "Get Schedule Info",
  "v2_schedule_create": "Create Schedule",
  "v2_schedule_update": "Update Schedule",
  "v2_schedule_delete": "Delete Schedule",
  "v2_schedule_status_set": "Change Schedule Status",

  // Firmware Update
  "xfer": "Update Firmware",

  // Manual Device Commands
  "v2_manual_get": "Get Manual Settings",
  "v2_manual_set": "Set Manual Settings",

  // pH Calibration Commands
  "set_ph_manually": "Set pH Value Manually",
  "calibrate_ph": "Calibrate pH",

  // ORP Calibration Commands
  "set_orp_manually": "Set ORP Value Manually",
  "calibrate_orp": "Calibrate ORP",

  // Device Settings Commands
  "get_device_settings_filter": "Get Device Function Settings",

  // Filter Pump Settings Commands
  "get_filter_pump_settings": "Get Filter Pump Settings",
  "set_filter_pump_settings": "Set Filter Pump Settings",
  "get_pump_settings": "Get Pump Settings",
  "set_pump_settings": "Set Pump Settings",

  // Heating Settings Commands
  "get_heating_settings": "Get Heating Settings",
  "set_heating_settings": "Set Heating Settings",

  // pH Settings Commands
  "get_ph_settings": "Get pH Settings",
  "set_ph_settings": "Set pH Settings",

  // Chlorine Settings Commands
  "get_chlorine_settings": "Get Chlorine Settings",
  "set_chlorine_settings": "Set Chlorine Settings",

  // Naked Pool Settings Commands
  "get_naked_pool_settings": "Get Naked Pool Settings",
  "set_naked_pool_settings": "Set Naked Pool Settings",

  // Light Settings Commands
  "lights_get": "Get Light Settings",
  "lights_set": "Set Light Settings",

  // History Logs Commands
  "errors_reset": "Reset Errors",

  // Backwash Commands
  "backwash_action": "Backwash Action",

  // Spa Commands
  "get_spa": "Get Spa Settings",
  "set_spa": "Set Spa Settings",

  // Wireless AddOns Commands
  "lora_search": "Get Wireless AddOns",
  "lora_cmd": "Change LoRa Device Name",
  "lora_remove": "Remove LoRa Device",
  "lora_pair": "Pair/Unpair LoRa Device",
  "lora_bind": "Bind Wireless Button",

  // Temperature Offset Commands
  "temp_offset_get": "Get Temperature Offset",
  "temp_offset_set": "Set Temperature Offset",

  // Monitor
  "/mon": "Monitor"
};

// Helper function to get human-readable command description
export const getCommandDescription = (command: string): string => {
  return COMMAND_DESCRIPTIONS[command] || command;
}; 
